import { html } from 'lit';

export const iconSave = html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M13.5312 3.0625C13.7812 3.3125 14 3.78125 14 4.125V12C14 13.125 13.0938 14 12 14H2C0.875 14 0 13.125 0 12V2C0 0.90625 0.875 0 2 0H9.875C10.2188 0 10.6875 0.21875 10.9062 0.4375L13.5312 3.0625ZM7 12C8.09375 12 9 11.125 9 10C9 8.90625 8.09375 8 7 8C5.875 8 5 8.90625 5 10C5 11.125 5.875 12 7 12ZM10 5.5V2.5C10 2.25 9.75 2 9.5 2H2.5C2.21875 2 2 2.25 2 2.5V5.5C2 5.78125 2.21875 6 2.5 6H9.5C9.75 6 10 5.78125 10 5.5Z"
    />
  </svg>
`;
